import { render, staticRenderFns } from "./MovimientosTarjeta.vue?vue&type=template&id=085dc8ca&scoped=true"
import script from "./MovimientosTarjeta.vue?vue&type=script&lang=js"
export * from "./MovimientosTarjeta.vue?vue&type=script&lang=js"
import style0 from "./MovimientosTarjeta.vue?vue&type=style&index=0&id=085dc8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085dc8ca",
  null
  
)

export default component.exports